module.exports = __webpack_public_path__ + "img/radio-labuan.859e980b.jpg";